<template>
  <svg viewBox="0 0 1486 256" class="footer__background">
    <title>Mountains</title>
    <polygon
      fill="#b4b5b5"
      points="0 178.132813 128 86.859375 239 178.132813 348 53.3203125 392 97.9765625 449 25.6953125 543.5 144.039063 594.695312 86.859375 643 144.039063 709.359375 53.3203125 813.460937 165.507812 873 101.914062 974 198.25 1057.28906 0 1145.96094 117.3125 1185.5625 53.3203125 1285.02344 178.132813 1342.79688 101.914063 1485.07031 210.320313 1485.07031 255.320313 0 255.320313"
    ></polygon>
  </svg>
</template>

<script>
export default {
  name: 'MountainsSVG'
};
</script>
